<template>
  <div class="container resultView">
    <div>
      <span class="back" @click="back">
        <i class="el-icon-arrow-left"></i> 返回
      </span>
    </div>
    <div class="commonWhiteBg">
      <div class="commonTitle">提交预览</div>
      <div class="MainStepsForm">
        <div class="formWrap">
          <el-form ref="form" label-width="140px">
            <el-form-item label="存证文件" prop="evidenceFile">
              <span v-for="(file, index) in orderInfo.files" :key="index"
                >{{ file.sourceName }}
              </span>
            </el-form-item>
            <el-form-item label="登记名称" prop="subject">
              {{ orderInfo.subject }}
            </el-form-item>
            <el-form-item
              label="权利权属"
              prop="ownership"
              class="ownershipRow"
            >
              {{ constants.ownership[orderInfo.ownership * 1].label }}
            </el-form-item>
            <el-form-item label="作者" prop="author">
              <span v-for="(author, index) in orderInfo.author" :key="index">{{
                author.obligeeType == "1" ? author.userName : author.companyName
              }}</span>
            </el-form-item>
            <el-form-item label="著作权人" prop="right">
              <span v-for="(author, index) in orderInfo.right" :key="index">{{
                author.obligeeType == "1" ? author.userName : author.companyName
              }}</span>
            </el-form-item>
            <el-form-item label="作品创作类型" prop="creationType">
              {{ constants.creationType[orderInfo.creationType * 1].label }}
            </el-form-item>
            <el-form-item label="作品创作性质" prop="creationNature">
              {{ constants.creationNature[orderInfo.creationNature * 1].label }}
            </el-form-item>
            <el-form-item label="创作完成时间" prop="finishTime">
              {{ orderInfo.finishTimeText }}
            </el-form-item>
            <el-form-item label="创作完成地点" prop="adress">
              {{ orderInfo.province
              }}{{ orderInfo.city
              }}{{ orderInfo.area }}
            </el-form-item>
            <el-form-item label="作品发表状态" prop="publishStatus">
              {{ constants.publishStatus[orderInfo.publishStatus * 1].label }}
            </el-form-item>
            <el-form-item label="权益拥有情况" prop="rightHave">
              <multiple-select
                v-model="orderInfo.rightHave"
                :isResultView="true"
                :listOpt="constants.right"
              ></multiple-select>
            </el-form-item>
            <el-form-item label="创作意图" prop="yitu">
              <el-input
                v-model="orderInfo.yitu"
                :rows="5"
                disabled
                placeholder="请输入创作意图"
                type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item label="作品独创性" prop="name">
              <el-input
                v-model="orderInfo.duchuang"
                :rows="5"
                disabled
                placeholder="请输入作品存证名称"
                type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="支付方式"
              prop="payStyle"
              class="choosePayStyle"
            >
              <el-radio-group v-model="orderInfo.paymode">
                <el-radio label="vip" v-if="orderInfo.paymode == 'vip'">
                  <span class="onlyText"
                    >中国知链会员权益支付（当前存证次数可用{{
                      vipInfo ? vipInfo.registerCount : 0
                    }}次）</span
                  >
                </el-radio>
                <el-radio label="alipay" v-if="orderInfo.paymode == 'alipay'">
                  <i class="iconfont aliPayColor"> &#xe634; </i>
                  <span>支付宝支付</span></el-radio
                >
                <!-- <el-radio label="wechat" v-if="orderInfo.paymode == 'wechat'">
                  <i class="iconfont weChatColor"> &#xe633; </i>
                  <span>微信支付</span></el-radio
                > -->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="支付金额" v-if="orderInfo.paymode != 'vip'">
              <div>
                <em class="bigPrice"> {{ orderInfo.orderAmount }} </em> 元
              </div>
            </el-form-item>
            <el-form-item class="submitRow">
              <el-button type="primary" @click="onGoPay">确认并支付</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <pay-dialog ref="payDialog" @close="onSetPayDialogClose"></pay-dialog>
  </div>
</template>

<script>
import multipleSelect from "../../../../../components/form/multipleSelect";
import PayDialog from "@/views/multipleService/components/PayDialog";
import {
  queryExistOrderItems,
  applyRegisterOrder,
} from "@/api/EvidenceService";
import { mapGetters } from "vuex";
import constants from "@/utils/constants";
export default {
  name: "registerResultView",
  components: { multipleSelect, PayDialog },
  props: {
    orderInfo: Object,
  },
  data() {
    return {
      constants,
    };
  },
  created() {
    this.init();
    this.orderInfo.finishTimeText = this.dayjs(
      this.orderInfo.finishTime
    ).format("YYYY-MM-DD");
  },
  computed: {
    ...mapGetters(["mid", "userInfo", "evidencePaymentPrice", "vipInfo"]),
  },
  methods: {
    init() {
      console.log("init result ..");
    },
    back() {
      this.$emit("set-tab-idx", "tab1");
    },
    onGoPay() {
      let that = this;
      if (that.order) {
        that.$refs.payDialog.showDialog(that.order);
        that.isPayDialogVisible = true;
        return false;
      }
      let params = {
        subject: that.orderInfo.subject,
        paymode: that.orderInfo.paymode,
        belong: that.orderInfo.ownership,
        authors: that.orderInfo.author.map((t) => {
          return t.obligeeCode;
        }),
        obligee: that.orderInfo.right.map((t) => {
          return t.obligeeCode;
        }),
        creationType: that.orderInfo.creationType,
        creationProperty: that.orderInfo.creationNature,
        completeTime: Math.round(that.orderInfo.finishTime.getTime() / 1000),
        completeLocation: {
          province: that.orderInfo.province,
          city: that.orderInfo.city,
          area: that.orderInfo.area,
        },
        publishStatus: that.orderInfo.publishStatus,
        copyrights: that.orderInfo.rightHave,
        creationIntention: {
          text: that.orderInfo.yitu,
        },
        creationOriginality: {
          text: that.orderInfo.duchuang,
        },
        items: that.orderInfo.files,
      };
      applyRegisterOrder(params).then(({ data }) => {
        that.order = data;
        if (data.paymentStatus == "21") {
          that.bus.$emit("refreshVip");
          that.onSetPayDialogClose(true);
        } else {
          that.$refs.payDialog.showDialog(data);
          that.isPayDialogVisible = true;
        }
      });
    },
    onSetPayDialogClose(result) {
      console.log(result);
      if (result) {
        //跳转至详情页
        this.$router.push({
          path: "/Register/Detail",
          query: { orderNo: this.order.orderNo },
        });
      }
    },
  },
};
</script>

<style lang='scss' scoped>
@import "../../../../../assets/css/inputForm.scss";
</style>
